import { type ReactElement } from 'react';
import { AlertTriangle } from 'lucide-react';

interface FieldErrorProps {
    message: string;
}

export function FieldError({ message }: FieldErrorProps): ReactElement {
    return (
        <div className="mt-1.5 flex items-center gap-1.5 text-destructive">
            <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
            <p className="text-xs">{message}</p>
        </div>
    );
}
